import React, { useMemo, useRef, useState } from 'react';
import Slider from 'react-slick';
import classNames from 'classnames';
import styles from './css/index.module.scss';
import LeftArrowIcon from '../../assets/icons/sliderLeftArrow.svg';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import './css/index.css';

function MySlider({
  frameHeight,
  frameWidth,
  objectFit = 'cover',
  images,

  dots = true,
  arrows = true,
  withEdging = true,
}) {
  const sliderRef = useRef(null);

  const settings = {
    dots,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 5000,
    arrows: false,
    speed: 1000,
    slidesToShow: 1,
    slidesToScroll: 1,
    focusOnSelect: false,
  };

  const onLeftClick = () => {
    if (!sliderRef.current) return;
    sliderRef.current.slickPrev();
  };

  const onRightClick = () => {
    if (!sliderRef.current) return;
    sliderRef.current.slickNext();
  };

  return (
    <div className={styles.wrapper}>
      <div
        className={classNames(styles.frame, { [styles.frameWithBorder]: withEdging })}
        style={{ height: `${frameHeight + 22}px`, width: frameWidth ? `${frameWidth}px` : undefined }}
      >
        <Slider ref={sliderRef} {...settings}>
          {images.map((image, i) => (
            <div key={i} tabIndex={-1} className={styles.sliderItem}>
              <img
                style={{ objectFit, height: `${frameHeight}px`, width: frameWidth ? `${frameWidth}px` : undefined }}
                className={classNames(styles.image, { [styles.imageBorderRadius]: withEdging })}
                src={image}
                alt="Slider Item"
              />
            </div>
          ))}
        </Slider>
      </div>
      {arrows && (
        <div className={styles.arrowsRow}>
          <div
            onClick={onLeftClick}
            className={classNames(styles.arrowButton, 'pressableLight')}
          >
            <img src={LeftArrowIcon} alt="<" />
          </div>
          <div
            onClick={onRightClick}
            className={classNames(styles.arrowButton, styles.arrowButtonRight, 'pressableLight')}
          >
            <img src={LeftArrowIcon} alt="<" />
          </div>
        </div>
      )}
    </div>
  );
}

export default MySlider;
